import { render } from "./BulkParcelListItem.vue?vue&type=template&id=4476c24f&scoped=true"
import script from "./BulkParcelListItem.vue?vue&type=script&lang=js"
export * from "./BulkParcelListItem.vue?vue&type=script&lang=js"

import "./BulkParcelListItem.vue?vue&type=style&index=0&id=4476c24f&scoped=true&lang=scss"

import exportComponent from "/opt/apps/myparcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4476c24f"]])

export default __exports__